<template>
  <div class="row">
    <div class="col-lg-12">
      <button type="button" class="btn btn-primary btn-voltar" @click="$router.back()">
        <font-awesome-icon :icon="'arrow-left'"/>
        Voltar
      </button>
      <h2 class="page-header">Edital {{ edital.numero }}</h2>

      <div class="row">
        <div class="col-xs-12">
          <div class="col-sm-4 text-center">
            <label class="custom-font">Processo</label>
            <p>{{ edital.processo_numero }}</p>
          </div>
          <div class="col-sm-4 text-center">
            <label class="custom-font">Publicado</label>
            <p :class="edital.publicado === 1 ? 'is-open' : 'is-closed'">
              {{ edital.publicado === 1 ? 'Sim' : 'Não' }}
            </p>
          </div>
          <div class="col-sm-4 text-center">
            <label class="custom-font">Status</label>
            <p :class="edital.status == 'Encerrado' ? 'is-closed' : 'is-open'">
              {{ edital.status }}
            </p>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-xs-12">
          <div class="col-xs-12 col-sm-6 col-md-4 col-lg-3">
            <div class="panel panel-primary">
              <div class="panel-heading">
                <div class="row">
                  <div class="col-xs-3">
                    <font-awesome-icon :icon="'address-card'" size="4x" />
                  </div>
                  <div class="col-xs-9 text-right">
                    <div class="huge">{{ habilitados.length }}</div>
                    <div>Habilitados</div>
                  </div>
                </div>
              </div>
              <a @click="scrollToElement('habilitados')">
                <div class="panel-footer">
                  <span class="pull-left">Detalhes</span>
                  <span class="pull-right"
                    ><font-awesome-icon
                      :icon="'arrow-alt-circle-right'"
                    ></font-awesome-icon
                  ></span>
                  <div class="clearfix"></div>
                </div>
              </a>
            </div>
          </div>

          <div class="col-xs-12 col-sm-6 col-md-4 col-lg-3">
            <div class="panel panel-primary">
              <div class="panel-heading">
                <div class="row">
                  <div class="col-xs-3">
                    <font-awesome-icon :icon="'bullhorn'" size="4x" />
                  </div>
                  <div class="col-xs-9 text-right">
                    <div class="huge">{{ nomeados.length }}</div>
                    <div>Nomeados</div>
                  </div>
                </div>
              </div>
              <a @click="scrollToElement('nomeados')">
                <div class="panel-footer">
                  <span class="pull-left">Detalhes</span>
                  <span class="pull-right"
                    ><font-awesome-icon
                      :icon="'arrow-alt-circle-right'"
                    ></font-awesome-icon
                  ></span>
                  <div class="clearfix"></div>
                </div>
              </a>
            </div>
          </div>

          <div class="col-xs-12 col-sm-6 col-md-4 col-lg-3">
            <div class="panel panel-primary">
              <div class="panel-heading">
                <div class="row">
                  <div class="col-xs-3">
                    <font-awesome-icon :icon="'user-check'" size="4x" />
                  </div>
                  <div class="col-xs-9 text-right">
                    <div class="huge">{{ empossados.length }}</div>
                    <div>Empossados</div>
                  </div>
                </div>
              </div>
              <a @click="scrollToElement('empossados')">
                <div class="panel-footer">
                  <span class="pull-left">Detalhes</span>
                  <span class="pull-right"
                    ><font-awesome-icon
                      :icon="'arrow-alt-circle-right'"
                    ></font-awesome-icon
                  ></span>
                  <div class="clearfix"></div>
                </div>
              </a>
            </div>
          </div>

          <div class="col-xs-12 col-sm-6 col-md-4 col-lg-3">
            <div class="panel panel-primary">
              <div class="panel-heading">
                <div class="row">
                  <div class="col-xs-3">
                    <font-awesome-icon :icon="'user-times'" size="4x" />
                  </div>
                  <div class="col-xs-9 text-right">
                    <div class="huge">{{ revogados.length }}</div>
                    <div>Revogados</div>
                  </div>
                </div>
              </div>
              <a @click="scrollToElement('revogados')">
                <div class="panel-footer">
                  <span class="pull-left">Detalhes</span>
                  <span class="pull-right"
                    ><font-awesome-icon
                      :icon="'arrow-alt-circle-right'"
                    ></font-awesome-icon
                  ></span>
                  <div class="clearfix"></div>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-xs-12">
          <h3>Cargos</h3>
          <data-table
            ref="list_cargos"
            :title="'Cargos'"
            :dados="cargos"
            :fields="fields.cargos"
            :carregando="isLoading"
          >
            <template slot="rowrender" slot-scope="props">
              <router-link
                title="Detalhes"
                class="btn btn-success"
                :to="{
                  name: 'acompanhamento_detalhes_cargo',
                  params: { edital_id: edital.id, cargo_id: props.rowData.id }
                }"
              >
                <font-awesome-icon :icon="'search'" />
              </router-link>
            </template>
          </data-table>
        </div>
      </div>

      <div class="row">
        <div class="col-xs-12">
          <h3 id="habilitados">
            <font-awesome-icon :icon="'address-card'" />
            Habilitados
          </h3>
          <data-table
            ref="list_habilitados"
            :dados="habilitadosNormal"
            :fields="fields.habilitados"
            :carregando="isLoading"
          >
          </data-table>
        </div>
      </div>

      <div class="row">
        <div class="col-xs-12">
          <h3>
            <font-awesome-icon :icon="'address-card'" />
            Habilitados - PCD
          </h3>
          <data-table
            ref="list_habilitadosPCD"
            :dados="habilitadosPCD"
            :fields="fields.habilitados"
            :carregando="isLoading"
          >
          </data-table>
        </div>
      </div>

      <div class="row">
        <div class="col-xs-12">
          <h3 id="nomeados">
            <font-awesome-icon :icon="'bullhorn'" />
            Nomeados
          </h3>
          <data-table
            ref="list_nomeados"
            :dados="nomeados"
            :fields="fields.nomeados"
            :carregando="isLoading"
          >
            <template slot="columncustom" slot-scope="props">
              {{ retornarTipoCandidato(props.rowData) }}
            </template>
          </data-table>
        </div>
      </div>

      <div class="row">
        <div class="col-xs-12">
          <h3 id="empossados">
            <font-awesome-icon :icon="'user-check'" />
            Empossados
          </h3>
          <data-table
            ref="list_empossados"
            :dados="empossados"
            :fields="fields.empossados"
            :carregando="isLoading"
          >
            <template slot="columncustom" slot-scope="props">
              {{ retornarTipoCandidato(props.rowData) }}
            </template>
          </data-table>
        </div>
      </div>

      <div class="row">
        <div class="col-xs-12">
          <h3 id="revogados">
            <font-awesome-icon :icon="'user-times'" />
            Revogados
          </h3>
          <data-table
            ref="list_revogados"
            :dados="revogados"
            :fields="fields.revogados"
            :carregando="isLoading"
          >
            <template slot="columncustom" slot-scope="props">
              {{ retornarTipoCandidato(props.rowData) }}
            </template>
          </data-table>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.custom-font {
  font-size: 16px;
  color: #00615c;
}

h3 {
  color: #00615c;
}

.is-closed {
  color: #990000;
}

.is-open {
  color: #468c36;
}
</style>

<script>
import DataTable from '@/components/common/NoApiTable'
import { request } from '@/request'
import { scrollToElement } from '@/utils'

export default {
  name: 'acompanhamento_detalhes',
  components: {
    DataTable
  },
  data() {
    return {
      fields: {
        cargos: [
          {
            name: 'data_homologacao',
            title: 'Homologação'
          },
          {
            name: 'descricao',
            title: 'Descrição'
          },
          {
            name: 'vagas',
            title: 'Vagas',
            titleClass: 'text-center',
            dataClass: 'text-center'
          },
          {
            name: 'ultima_nomeacao',
            title: 'Ultima Nomeação',
            titleClass: 'text-center',
            dataClass: 'text-center'
          },
          {
            name: 'data_validade',
            title: 'Validade',
            titleClass: 'text-center',
            dataClass: 'text-center'
          },
          {
            name: '__slot:actions',
            title: 'Ações',
            titleClass: 'text-center',
            dataClass: 'text-center col-xs-1'
          }
        ],
        habilitados: [
          {
            name: 'classificacao',
            title: 'Classificação'
          },
          {
            name: 'nome',
            title: 'Nome'
          },
          {
            name: 'descricao',
            title: 'Cargo'
          },
          {
            name: 'data_habilitado',
            title: 'Data Habilitação',
            titleClass: 'text-center',
            dataClass: 'text-center'
          }
        ],
        nomeados: [
          {
            name: '__slot:column',
            title: 'Tipo Candidato'
          },
          {
            name: 'classificacao',
            title: 'Classificação'
          },
          {
            name: 'nome',
            title: 'Nome'
          },
          {
            name: 'descricao',
            title: 'Cargo'
          },
          {
            name: 'data_nomeacao',
            title: 'Data Nomeação',
            titleClass: 'text-center',
            dataClass: 'text-center'
          }
        ],
        empossados: [
          {
            name: '__slot:column',
            title: 'Tipo Candidato'
          },
          {
            name: 'classificacao',
            title: 'Classificação'
          },
          {
            name: 'nome',
            title: 'Nome'
          },
          {
            name: 'descricao',
            title: 'Cargo'
          },
          {
            name: 'data_nomeacao',
            title: 'Data Nomeação',
            titleClass: 'text-center',
            dataClass: 'text-center'
          }
        ],
        revogados: [
          {
            name: '__slot:column',
            title: 'Tipo Candidato'
          },
          {
            name: 'classificacao',
            title: 'Classificação'
          },
          {
            name: 'nome',
            title: 'Nome'
          },
          {
            name: 'descricao',
            title: 'Cargo'
          },
          {
            name: 'data_nomeacao',
            title: 'Data Nomeação',
            titleClass: 'text-center',
            dataClass: 'text-center'
          }
        ]
      },
      edital: {
        id: 0,
        numero: '',
        processo: '',
        publicado: '',
        status: ''
      },
      cargos: [],
      habilitados: [],
      isLoading: false
    }
  },
  beforeCreate() {
    if (!this.$store.state.isLogged) {
      this.$router.push('/login')
    }
  },
  created() {
    this.edital.id = this.$router.history.current.params.edital_id

    this.carregarEdital()
    this.carregarCargos()
    this.carregarHabilitados()
  },
  computed: {
    habilitadosNormal() {
      return this.habilitados.filter(item => item.tipo_normal === 1)
    },
    habilitadosPCD() {
      return this.habilitados.filter(item => item.tipo_pcd === 1)
    },
    nomeados() {
      return this.habilitados.filter(item => {
        return (
          item.data_nomeacao && !item.data_empossado && !item.data_revogacao
        )
      })
    },
    empossados() {
      return this.habilitados.filter(item => !!item.data_empossado)
    },
    revogados() {
      return this.habilitados.filter(item => !!item.data_revogacao)
    },
    editalId() {
      return this.edital.id
    }
  },
  methods: {
    retornarTipoCandidato({ tipo_pcd, tipo_cotas }) {
      if (tipo_pcd) {
        return 'PCD'
      }

      if (tipo_cotas) {
        return 'Cotas'
      }

      return 'Geral'
    },
    carregarEdital() {
      const { editalId, toogleLoading } = this
      toogleLoading()

      request
        .get(`edital/${editalId}`)
        .then(response => (this.edital = response.data))
        .catch(error => console.log(error.response))
        .then(toogleLoading)
    },
    carregarCargos() {
      const { editalId, toogleLoading } = this
      toogleLoading()

      request
        .get('cargo', { params: { edital_id: editalId } })
        .then(response => (this.cargos = response.data))
        .catch(error => console.log(error.response))
        .then(toogleLoading)
    },
    carregarHabilitados() {
      const { editalId, toogleLoading } = this
      toogleLoading()

      request
        .get('habilitado', { params: { edital_id: editalId } })
        .then(response => (this.habilitados = response.data))
        .catch(error => console.log(error.response))
        .then(toogleLoading)
    },
    toogleLoading() {
      this.isLoading = !this.isLoading
    },
    scrollToElement
  }
}
</script>

<style scoped>
.huge {
  font-size: 40px;
}
.panel-primary > .panel-heading {
  background-color: #00615c !important;
  border-color: #00615c !important;
}
.panel-primary {
  border-color: #00615c !important;
}
.btn-voltar {
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/views/admin/concursos/acompanhamento/Details.vue